import { USER_SETTING_CHART_PREFERENCES } from './userSettingKeys';

const isPlainObject = (value) => Boolean(value) && typeof value === 'object' && !Array.isArray(value);

const deepEqual = (left, right) => {
  if (left === right) return true;
  if (Array.isArray(left) && Array.isArray(right)) {
    return left.length === right.length && left.every((value, i) => deepEqual(value, right[i]));
  }
  if (isPlainObject(left) && isPlainObject(right)) {
    const keys = Object.keys(left);
    return keys.length === Object.keys(right).length &&
      keys.every((key) => Object.prototype.hasOwnProperty.call(right, key) && deepEqual(left[key], right[key]));
  }
  return false;
};

// The entries of chartPreferences the save changed, one per symbol (and __global). An entry the
// save no longer carries, or carries as null, was cleared: null is how the API deletes one.
const chartPreferencesChange = (base, sent) => {
  const before = isPlainObject(base) ? base : {};
  const after = isPlainObject(sent) ? sent : {};
  const change = {};
  Object.entries(after).forEach(([entry, value]) => {
    if (!deepEqual(value, before[entry] ?? null)) change[entry] = value;
  });
  Object.keys(before).forEach((entry) => {
    if (!(entry in after) && before[entry] != null) change[entry] = null;
  });
  return change;
};

/**
 * A save that lost a concurrent-update race (409), rebuilt on a fresh read: what `sent` changed
 * relative to `base` — the settings it was built from — applied to `fresh`. Everything else is
 * taken from `fresh`, so the retry carries this save's change and nobody else's stale copy:
 * top-level settings by key, chartPreferences by symbol.
 */
export function reapplySettingsChange({ fresh = {}, base = {}, sent = {} }) {
  const next = { ...fresh };
  Object.entries(sent).forEach(([key, value]) => {
    if (key === USER_SETTING_CHART_PREFERENCES) {
      const change = chartPreferencesChange(base[key], value);
      if (Object.keys(change).length > 0) {
        next[key] = { ...(isPlainObject(fresh[key]) ? fresh[key] : {}), ...change };
      }
      return;
    }
    if (!deepEqual(value, base[key])) next[key] = value;
  });
  return next;
}
